import { render, staticRenderFns } from "./welderStyle.vue?vue&type=template&id=0542eb9e&"
import script from "./welderStyle.vue?vue&type=script&lang=js&"
export * from "./welderStyle.vue?vue&type=script&lang=js&"
import style0 from "./welderStyle.vue?vue&type=style&index=0&id=0542eb9e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports